import { BaseIcon } from '../BaseIcon';
import type { BaseIconProps } from '../BaseIcon';

type AlertIconProps = Omit<BaseIconProps, 'children'>;

export const AlertIcon = ({ ...props }: AlertIconProps) => (
  <BaseIcon hasLegacyStrokeStyles={true} width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z"
      stroke="none"
    />
    <g strokeWidth={2} strokeMiterlimit="10" strokeLinejoin="round">
      <path d="M12 9.5V14" />
      <path d="M4 19L12 4L20 19H4Z" fill="none" />
    </g>
  </BaseIcon>
);

AlertIcon.displayName = 'AlertIcon';
